var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_154_325)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5 35C27.165 35 35 27.165 35 17.5C35 7.83502 27.165 0 17.5 0C7.83502 0 0 7.83502 0 17.5C0 27.165 7.83502 35 17.5 35Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1611 14.2411H13.5503V25.1291H10.1611V14.2411ZM11.8565 8.83032C12.9403 8.83032 13.8186 9.70963 13.8186 10.7914C13.8186 11.8731 12.9403 12.755 11.8565 12.755C10.7726 12.755 9.89172 11.8741 9.89172 10.7914C9.89172 9.70856 10.77 8.83032 11.8565 8.83032Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.674 14.241H18.9202V15.7303H18.9648C19.4175 14.8733 20.5215 13.9717 22.1696 13.9717C25.596 13.9717 26.2277 16.2249 26.2277 19.1577V25.1295H22.846V19.8362C22.846 18.5727 22.8215 16.9491 21.0868 16.9491C19.3521 16.9491 19.0562 18.3246 19.0562 19.7443V25.1301H15.674V14.2421V14.241Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_154_325"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInIcon);
export default __webpack_public_path__ + "static/media/in-icon.fbee6b85c017eb764ac203408da88b24.svg";
export { ForwardRef as ReactComponent };